import styled from 'styled-components';

const InputWrapper = ComponentName => styled(ComponentName)`
  &.ant-input {
    padding: 4px 10px;
    width: 100%;
    height: 35px;
    cursor: text;
    text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
    font-size: 13px;
    line-height: 1.5;
    color: #595959;
    background-color: #fff;
    background-image: none;
    border: 1px solid #e9e9e9;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-transition: 4px;
    -o-border-radius: 4px;
    border-radius: 4px;
    -webkit-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -moz-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -ms-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -o-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

    &:focus {
      border-color: #00598d;
    }

    &.ant-input-lg {
      height: 42px;
      padding: 6px 10px;
    }

    &.ant-input-sm {
      padding: 1px 10px;
      height: 30px;
    }

    &::-webkit-input-placeholder {
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: #bababa;
    }

    &:-moz-placeholder {
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: #bababa;
    }

    &::-moz-placeholder {
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: #bababa;
    }
    &:-ms-input-placeholder {
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: #bababa;
    }
  }
`;

const TextAreaWrapper = ComponentName => styled(ComponentName)`
  &.ant-input {
    padding: 4px 10px;
    width: 100%;
    height: auto;
    cursor: text;
    font-size: 13px;
    line-height: 1.5;
    color: #595959;
    background-color: #fff;
    background-image: none;
    border: 1px solid #e9e9e9;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-transition: 4px;
    -o-border-radius: 4px;
    border-radius: 4px;
    -webkit-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -moz-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -ms-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    -o-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1)

    &:focus {
      border-color: #00598d;
    }

    &::-webkit-input-placeholder {
      color: #bababa;
    }

    &:-moz-placeholder {
      color: #bababa;
    }

    &::-moz-placeholder {
      color: #bababa;
    }
    &:-ms-input-placeholder {
      color: #bababa;
    }
  }
`;

export { InputWrapper, TextAreaWrapper };


// WEBPACK FOOTER //
// ./src/components/UI/styles/input.style.js